import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changePropertyType } from 'bundles/apex/deals/form/store/deal/actions';

import DealField, { propTypes } from 'bundles/apex/deals/form/fields/field';
import PropertyTypeInputs from 'components/property_type_inputs';

export function PropertyType({ changePropertyType, deal, invalid, propertyTypes, required }) {
  return (
    <PropertyTypeInputs
      hasError={invalid}
      includeBlank
      propertySubtypeId={deal.propertySubtypeId}
      propertyTypeId={deal.propertyTypeId}
      propertyTypes={propertyTypes}
      required={required}
      onChange={changePropertyType}
    />
  );
}

PropertyType.propTypes = {
  ...propTypes,
  changePropertyType: PropTypes.func.isRequired,
  propertyTypes: PropTypes.array,
};

const mapStateToProps = state => ({
  propertyTypes: state.options.propertyTypes,
});

const mapDispatchToProps = {
  changePropertyType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealField(PropertyType, 'propertyType'));
